import { useState } from 'react'
import Register from './Register'
import Login from './Login'
import { useAuth } from "../contexts/AuthProvider";

function AuthLogin() {
  const [showRegister, setShowRegister] = useState(false);
  const { user }: any = useAuth();

  const { auth, signOut }: any = useAuth();

  const handleShowRegisterChange = () => {
    setShowRegister(!showRegister);
  };

  const handleLogout = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    try {
      const { error } = await signOut();
      console.log(error);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    auth ? (<>
      <div className="w-full text-center flex justify-center items-center space-x-2">
        <p>Logged in as {user.email}</p>
        <button onClick={handleLogout} className="font-semibold p-2 btn-primary rounded-full mt-4 md:mt-auto items-center justify-center">Logout</button>
      </div>
    </>) :
      (<>
        <button className="btn btn-primary" onClick={() => {
          const modal = document.getElementById('my_modal_3') as HTMLDialogElement;
          if (modal) {
            modal.showModal();
          }
        }}>Login/Register</button>
        <dialog id="my_modal_3" className="modal">
          <div className="modal-box">
            <form method="dialog">
              <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
            </form>
            {showRegister ? <Register /> : <Login />}
            <div className="w-full text-center flex justify-center items-center space-x-2">
              {showRegister ? <p>Existing User?</p> : <p>New User?</p>}
              <button onClick={handleShowRegisterChange} className="text-xl font-semibold">{showRegister ? "Login" : "Register"}</button>
            </div>
          </div>
        </dialog>
      </>)
  );
}

export default AuthLogin;